import React, {useCallback} from 'react';
import {Pressable, StyleProp, View, ViewStyle} from 'react-native';
import {images} from '../../../assets/icons';
import {useStyles} from '../../hooks/styles';
import {Text} from '../text';
import {Column, SortDirection} from './model';

interface ColumnHeadProps<T> {
  column: Column<T>;
  activeSortOrder?: SortDirection;
  onColumnSortOrder?: (sortOrder: SortDirection) => void;
  colHeadStyle?: StyleProp<ViewStyle>;
  colHeadTextStyle?: StyleProp<ViewStyle>;
}

export function ColumnHead<T extends Record<string, any>>({
  column,
  activeSortOrder = 'none' as const,
  onColumnSortOrder,
  colHeadStyle,
  colHeadTextStyle,
}: ColumnHeadProps<T>) {
  const styles = useStyles(({theme}) => ({
    colHead: {
      paddingTop: 4,
      paddingBottom: 4,
    },
    colHeadText: {
      ...theme.fonts.body,
      color: theme.color.labelText,
    },
    colHeadIcon: {
      justifyContent: 'center',
      transform: [{rotate: activeSortOrder === 'asc' ? '180deg' : '0deg'}],
      color: activeSortOrder === 'none' ? '#C0CDD6' : theme.color.primaryColor,
    },
  }));

  const handleSortPress = useCallback(() => {
    let order: SortDirection = 'desc';

    if (activeSortOrder === 'desc') order = 'asc';
    if (activeSortOrder === 'asc') order = 'none';

    onColumnSortOrder?.(order);
  }, [activeSortOrder]);

  return (
    <View style={[styles.colHead, colHeadStyle]}>
      <Text
        testID={column.titleTestID}
        numberOfLines={column.titleNumberOfLines}
        style={[styles.colHeadText, colHeadTextStyle]}>
        {column.title}
      </Text>
      {column.sortable && (
        <Pressable style={{marginLeft: 8}} onPress={handleSortPress}>
          <View style={styles.colHeadIcon}>
            <images.ArrowDown2 width={11} height={12} color='inherit' />
          </View>
        </Pressable>
      )}
    </View>
  );
}
